import FrenchEmails from "./FrenchEmails";

export default FrenchEmails;
